"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shimmer = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var highlight = 'rgba(0, 0, 0, 0.0)';
var lowlight = 'rgba(0, 0, 0, 0.1)';

var linearGradient = function linearGradient() {
  return "linear-gradient(\n    to right, " + lowlight + " 0%,\n    " + highlight + " 0%,\n    " + lowlight + " 40%,\n    " + highlight + " 100%\n  )";
};

var Shimmer = (0, _styledComponents.default)(_Box.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  background: rgba(0, 0, 0, 0.1);\n  background-image: ", ";\n  background-repeat: no-repeat;\n  position: relative;\n  min-height: 4px;\n  min-width: 100px;\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeholderShimmer;\n  animation-timing-function: linear;\n\n  @keyframes placeholderShimmer {\n    0% {\n      background-position: -2000px 0;\n    }\n\n    100% {\n      background-position: 2000px 0;\n    }\n  }\n"], ["\n  background: rgba(0, 0, 0, 0.1);\n  background-image: ", ";\n  background-repeat: no-repeat;\n  position: relative;\n  min-height: 4px;\n  min-width: 100px;\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeholderShimmer;\n  animation-timing-function: linear;\n\n  @keyframes placeholderShimmer {\n    0% {\n      background-position: -2000px 0;\n    }\n\n    100% {\n      background-position: 2000px 0;\n    }\n  }\n"])), linearGradient);
exports.Shimmer = Shimmer;
var templateObject_1;